import { useEffect, useRef, useState } from 'react'

export const useFormChanges = <T extends Record<string, any>>({
  watchedValues,
  initialValues,
  areFieldsDirty,
}: {
  watchedValues: T
  initialValues: T
  areFieldsDirty: boolean
}) => {
  const [needsRecalculation, setNeedsRecalculation] = useState(false)
  const initialValuesRef = useRef<T>(structuredClone(initialValues)) // Ensure deep copy

  useEffect(() => {
    if (!watchedValues || !initialValues) return

    const isModified = Object.keys(watchedValues).some((key) => {
      if (Array.isArray(watchedValues[key])) {
        return watchedValues[key].some(
          (item, index) =>
            JSON.stringify(item) !==
            JSON.stringify(initialValuesRef.current[key]?.[index] || [])
        )
      }

      return (
        JSON.stringify(watchedValues[key] || []) !==
        JSON.stringify(initialValuesRef.current[key] || [])
      )
    })

    setNeedsRecalculation(isModified && areFieldsDirty)
  }, [watchedValues, areFieldsDirty])

  const resetChanges = (newInitialValues?: T) => {
    initialValuesRef.current = structuredClone(
      newInitialValues || watchedValues
    )
    setNeedsRecalculation(false)
  }

  return { needsRecalculation, resetChanges }
}
